import CollapsePanel from './collapsePanel';

export default CollapsePanel;
